/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Tutorial_ZoomInputs */

const en_camera_tutorial_zoom = /** @type {(inputs: Camera_Tutorial_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scroll wheel · zoom`)
};

const fr_camera_tutorial_zoom = /** @type {(inputs: Camera_Tutorial_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molette · zoom`)
};

const ms_sg2_camera_tutorial_zoom = /** @type {(inputs: Camera_Tutorial_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roda tatal · zum`)
};

/**
* | output |
* | --- |
* | "Scroll wheel · zoom" |
*
* @param {Camera_Tutorial_ZoomInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const camera_tutorial_zoom = /** @type {((inputs?: Camera_Tutorial_ZoomInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Tutorial_ZoomInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_camera_tutorial_zoom(inputs)
	if (locale === "fr") return fr_camera_tutorial_zoom(inputs)
	return ms_sg2_camera_tutorial_zoom(inputs)
});